import { calculateAge } from '../models/interface.helper'

import { IPaperworkTeam } from '../models/user-documents/user-documents.interface'
import { IRegistrationByDayInterface } from '../models/registrations-by-day/registrationByDay.interface'

import { signedStatuses } from '../const/data/v01/rider-team-members/firestore-v01-rider-team-member-const'

import { CONST } from '../const/const'

export const isValidPaperwork = (teamMembers: IPaperworkTeam[]) => {
  const haveRider = teamMembers.some(
    (item) => item.teamMemberRole === CONST.UI.TEAM_MEMBERS_ROLES.RIDER
  )
  const haveDocuments =
    teamMembers.filter((teamMember) => {
      const age = calculateAge(teamMember?.teamMemberDob)

      const notSigned =
        teamMember.documents?.[0] &&
        teamMember.documents.some((document) => document.status === signedStatuses.NOT_SIGNED)

      const guardian = teamMember.teamMemberRole === CONST.UI.TEAM_MEMBERS_ROLES.GUARDIAN

      const missedGuardian =
        age < 18 && teamMember.teamMemberRole === CONST.UI.TEAM_MEMBERS_ROLES.RIDER && !guardian

      return notSigned || missedGuardian
    }).length > 0

  return haveDocuments || !haveRider
}

export const getRidersByPaperwork = (registrationsByDay: IRegistrationByDayInterface[]) => {
  const allRiders: IRegistrationByDayInterface[] = []
  registrationsByDay.forEach((item) => {
    item.horsesSelected.forEach((horse) => {
      const isExist = allRiders.find(
        (current) => current.riderId === item.riderId && current.horseId === item.horseId
      )
      if (!isExist) {
        allRiders.push({
          ...item,
          horseId: horse.id,
          horseName: horse.name,
          horseProfilePicture: horse.picture,
        })
      }
    })
  })

  return allRiders
}
